module.exports = scripts;


//////////////////
// WEBPACK FOOTER
// external "scripts"
// module id = 3
// module chunks = 0